import { PersistGate } from "redux-persist/integration/react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { StrictMode } from "react";
import store, { persistentStore } from "./redux/store";
import App from "@/App.tsx";
import "@daypicker/react/style.css";
import "./index.css";
import type { RowData, TableFeatures } from "@tanstack/table-core";

export type ColumnId = "impressions" | "clicks" | "retarget_impressions" | "retarget_clicks" | "ctr";
declare module "@tanstack/table-core" {
	interface TableMeta<TFeatures extends TableFeatures, TData extends RowData> {
		readonly _tableFeatures?: TFeatures;
		updateData: (rowIndex: number, columnId: string, value: string, row: TData) => void;
	}
}

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistentStore}>
				<App />
			</PersistGate>
		</Provider>
	</StrictMode>,
);
